import styled from 'styled-components'
import { borders, colors, fontSizes, fontWeights, spacings } from 'styles/theme'

interface ImagePreviewProps {
  imageUrl: string,
  width?: number;
  height?: number;
}

export const HeaderContainer = styled.header`
display: flex;
flex-direction: column;
justify-content: space-between;
top: 0px;
left: 88px;
width: calc(100% - 88px);
height: 115px;
border-bottom: 1px solid ${colors.neutral_regular};
background: ${colors.white};

.header-text{
  display: flex;
  
  h1{
    padding-bottom: ${spacings.sl};
    display: inline;
    border-bottom: ${spacings.xs} solid ${colors.primary};
  }

  h2{
    margin-right: ${spacings.xs};
  }
}
`

export const OutSideContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;

  margin: 2rem 0;

  width: fit-content;

  .select-container{
    display: flex;
    min-width: 500px;
  }
`

export const Container = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  margin-bottom: 2rem;

  > div{
    flex: 1;
    margin: 0;
    
    &:last-child{
      margin-left: 2rem;
    }
  }
`

export const Content = styled.div`
  margin-bottom: 40px;

  .subtitle-small{
    display: block;
    margin-bottom: 34px;
  }

  .warning{
    display: block;
    color: ${colors.neutral_darkest};
    margin-bottom: 2rem;
  }
`

export const SideContainer = styled.div`
  &+div{
    margin-left: 2rem;
  }

  #valid-data{
    strong{
      display: block;
      margin-bottom: 1.5rem;
    }

    button{
      min-width: 250px;
    }
  }
`

export const CardItem = styled.span`
  padding: calc(1rem - 2px);
  margin-left: 1rem;

  white-space: nowrap;

  border: 2px solid ${colors.primary};
  border-radius: 0.5rem;

  font-size: 14px;
  font-weight: 700;
  font-family: "DM Sans";

  &:last-child{
    margin-right: 0;
  }

`

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  white-space: nowrap;

  > span{
    font-family: "DM Sans";
    font-weight: 500;
    font-size: 18px;    
    color: ${colors.neutral_darkest}
  }

  > div:nth-child(2){
    margin-left: 2rem;
  }

  &.select-container{
    margin-bottom: 40px;
  }

  button{
    &+button{
      margin-left: 1.5rem;
    }
  }
`

export const Subtitle = styled.p`
  font-weight: 700;
  margin: 2rem 0;
  color: ${colors.neutral_darkest};
  font-size: 24px;
`

//LOGO

export const LogoCard = styled.div`
  display: flex;
`

export const ImageDetails = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  
  padding-left: 1.5rem;
  margin-bottom: 40px;

  > span{
    margin-bottom: 0.5rem;
    font-weight: 700;
    font-size: 12px;
  }
`

export const ImagePreview = styled.div<ImagePreviewProps>`
  min-width: ${props => props.width ?? 80}px;
  max-width: ${props => props.width ?? 80}px;
  height: ${props => props.height ?? 80}px;
  background-color: blue;
  border-radius: 16px;
  background-image: url('${props => props.imageUrl}');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center; 
`

export const SocialMediaBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: fit-content;
  height: fit-content;

  padding: 1rem;
  margin-bottom: 40px;

  background: ${colors.neutral_light};
  border-radius: 0.5rem;

  svg{
    width: 24px;
    height: 24px;
  }
`

export const SessionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const BoxSupportContact = styled.div`
  margin-top: 40px;
`

export const MessageAlert = styled.p`
  margin-bottom: 40px;
  padding: 1.5rem;

  border: 2px solid ${colors.secondary_four};
  border-radius: 1rem;
  font-weight: 700;
  text-align: center;

  background: ${colors.secondary_four_light};
  color: white;
`

export const BusinessTrustCard = styled.div`
  margin-right:  ${spacings.lg};
  margin-top:  ${spacings.md};
  padding:  ${spacings.md}  ${spacings.ls};
  border: ${borders.xs} solid ${colors.neutral_regular};
  border-radius: ${borders.lg};
  margin-bottom: ${spacings.ls};
  background-color: transparent;
  transition: all 0.2s linear;
  min-width: 150px;

  &:last-child{
    margin-right: 0;
    width: 100%;
  }

  span{
    font-style: normal;
    font-weight: ${fontWeights.w700};
    font-size: ${fontSizes.xs};
    color: ${colors.neutral_darker};
  }
  
  .data-container{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 0.25rem;
    
    h2{
      display: inline-block;
      font-family: DM Sans;
      font-style: normal;
      font-weight: ${fontWeights.w700};
      font-size: ${fontSizes.xl};
      color: ${colors.neutral_darkest};
      margin-right: 1.5rem;
    }

    .button-link{
      min-height: 37px;
      height: 37px;
      max-width: 300px;
    }
    
  }
`

export const CardStatus = styled.div`
  background: ${colors.white};
  border-radius: ${borders.md};
  padding: ${spacings.lg};

  font-family: "DM Sans";
  font-weight: 700;

  .approved{
    color: ${colors.secondary_one};
  }
  
  .disapproved{
    color: ${colors.secondary_four};
  }

  .reproved-reason{
    display: block;
    margin-top: 1.5rem;
  }
`

export const ContactContainer = styled.div`

  > div:first-child{
    align-items: flex-start;
    button{
      min-height: 54px;
      min-width: 54px;
      margin-left: 1rem;
    }
  }

  
  &+div{
    margin-top: 40px;
  }
`